export { createStrategyShortcutObject }
import { remapStrategySubject } from '@/api/presentlevels'

function createStrategyShortcutObject(subject, barrier, enrolledGrades) {
  if (barrier.includes('/')) {
    let subjBarrierParts = barrier.split('/')
    subject = subjBarrierParts[0]
    barrier = subjBarrierParts[1]
  }
  return {
    subject: remapStrategySubject(subject),
    barrier: barrier,
    grades: enrolledGrades,
  }
}
